<template>
    <div class="body">
    <!-- header开始 -->
    <v-header></v-header>
    <!-- header结束 -->
    <div class="conH"></div>
        <div class="userinfo">
            <div class="area-1">
                <img @click="goPerson()" :src="src" class="pointer"/>
                <div class="title">
                    <label>{{user.psnName}}</label>
                    <label @click="goCertificate()" class="pointer epctxt" v-if="level">电子执业证</label>
                </div>
            </div>
            <div class="area-2" v-if="level">
                <span>{{YearMonth}} 收入总额（元）</span>
                <span v-if="(money===false&&totalIncome!=='')"  class="">*****</span>
                <span  v-if="(money===true)" @click="gomyIncome" class="pointer">{{totalIncome}}</span>
                <div v-if="(totalIncome!=='')" style="display:inline-block; height:30px;">
                    <img v-if="(money===false)" @click="moneyclick" style="display: block;width: 22px;cursor:pointer;"  src="../../assets/user/hidden_icon_personal center@2x.png" alt="">
                    <img v-if="(money===true)" @click="moneyclickNot" style="display: block;width: 22px;cursor:pointer;" src="../../assets/user/show_icon_personal center@2x.png" alt="">
                </div>
            </div>
            <div class="area-3" v-if="level">
                <button class="trajectory pointer" @click="gotrajectory" >
                    <label class=" pointer">{{user.rankName}}</label>
                    <label class=" pointer">查看轨迹</label>
                </button>
            </div>
        </div>
        <div class="">
            <ul>
                <li  class="pointer" @click="go_getPolicyList(menu)" v-for="(menu,index) in result" :key="index">
                    <img :src="menu.imUrl" />
                    <label class="pointer">{{menu.privName}}</label>
                </li>


                <!-- <li @click="go_personAssess()">
                    <img src="../../assets/user/kehuxinxi_icon@2x.png"/>
                    <label>考核信息</label>
                </li>
                <li>
                    <img src="../../assets/user/personalcenter@2x.png"/>
                    <label>客户信息</label>
                </li> -->
            </ul>
        </div>
    </div>
</template>

<script>
import url from '@/modules/url'
import api from '@/modules/api'
import vHeader from '@/layout/Header.vue'
export default {
  components: {
    vHeader
  },
  data () {
    return {
      money: false,
      req: {
        pid: ''
      },
      src: 'http://111.160.216.85/eapp2/eapp-getFile/',
      totalIncome: '',
      user: '',
      count: 0,
      dialogVisible: false,
      reddot:false,//header铃铛上面的红点
      result:[],
      YearMonth:'',
      level: false
    }
  },
  methods: {
    getMenuInfo () {
          let submitInfo = {
            pid: '5d3659ce7f534f079fe34956375c35e6'
          }
          let that = this
          // 调用接口保存告知数据
          api.getMenuInfo(submitInfo, res => {
            if (res.result.isSuccess === true) {
              if (res.data.menus.children != null && res.data.menus.children.length > 0) {
                that.result = res.data.menus.children
              } else {
                that.nonestatus = true
              }
            } else {
              that.$toast(res.result.error)
            }
          })
        },

    moneyclick () {
      this.money = true
    },
    moneyclickNot () {
      this.money = false
    },
    gotrajectory () {
      this.$router.push({path: '/home/trajectory'})
    },
    gomyIncome () {
      this.$router.push({path: '/home/myIncome'})
    },
    goPerson () {
      this.$router.push({path: '/home/userinfo'})
    },
    go_personAssess () {
      this.$router.push({path: '/home/personAssess'})
    },
    goCertificate () {
      this.$router.push({path: '/home/certificate'})
    },
    go_getPolicyList (val) {
      if(val.url.includes('http')){
        window.location.href = val.url;
      } else if (val.privName == '投保单查询') {
        window.location.href = val.url
      } else if (val.url.includes('http')) {
        window.location.href = val.url
      } else{
        this.$router.push({name: val.url})
      }
    },
    init () {
      let that = this
      api.post(url.getPuserInfo, this.req, function (res) {
        that.user = res.data
        if (that.user.sexName === '女') {
          that.src = that.src + 'salm-' + that.user.pId + '.jpg'
        } else {
          that.src = that.src + 'sal-' + that.user.pId + '.jpg'
        }
      })
    },
    getUserRoles () {
      let that = this
      const params = {
        platform: 'PC'
      }
      api.post(url.getUserRoles, params, function (res) {
        const roleArr = new Set(res.data)
        that.level = roleArr.has('RI_AGENT')   // 个险外勤
      })
    },
    getPersonalIncome (datas) {
      console.log(datas)
      let str = datas.replace('-', '')
      let submitInfo =
        {
          'PID': window.sessionStorage.getItem('username'),
          'MONTH': str
        }   
      let that = this
      let tempYear = str.slice(0,4);
      let tempMonth = str.slice(4,6);
      // alert(tempYear+"年"+tempMonth)
      that.YearMonth = tempYear+"年"+tempMonth+"月"
      console.log(submitInfo)
      // 调用接口保存告知数据
      api.getPersonalIncome(submitInfo, function (res) {
        console.log(res)
        if (res.result.isSuccess === true) {
          that.totalIncome = res.data.data.awi125

        } else {
          if (that.count < 3) {
            console.log(str)
            
            let year = str.slice(0, 4);
            let month = str.slice(4, 6);
            let date = year + "/" + month + "/" + "01";
            let now = new Date(date);
            let perMonth = new Date(now.setMonth(now.getMonth() - 1));
            let month2 = perMonth.getMonth() + 1;
            
            if (month2 < 10) {
              month2 = '0' + month2;
            }
            let reqDate =
              perMonth.getFullYear() + "" + month2;
            that.getPersonalIncome(reqDate);
            that.count++;
          } else {
            that.$toast(res.result.error)
          }
        }
      })
    },
    changeDates () {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      if (month < 10) {
        var ymonth = '0' + month
      } else {
        ymonth = month
      }
      let time = year + '-' + ymonth
      return time
    }
  },
  mounted () {
    this.init();
    this.getMenuInfo();
    this.getUserRoles()
  },
  created: function () {
    let date = this.changeDates()
    this.getPersonalIncome(date)
  }
}
</script>

<style scoped>
.body{
    font-family:"Microsoft YaHei";
    font-weight:500;
}
.userinfo{
    width: 95%;
    height: 144px;
    background: #ffffff;
    border: 1px solid #D7D7D7;
    margin: 0 auto;
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);
    margin-top:20px;
    display: flex;
    justify-content: space-between;
}
.area-1{
    /* float: left;
    width: 25%; */
    height: 98px;
    padding: 23px 0px 23px 30px;
}
.area-1 img{
    width: 71px;
    display: block;
    float: left;
}
.title{
    float: right;
    padding-top:20px;
    margin-left: 20px;
}
.trajectory{
    /* width:164px; */
    height:68px;
    background:linear-gradient(60deg,rgba(28,111,223,1),rgba(77,160,214,1));
    border-radius:5px;
    border: none;
    color: #ffffff;
    outline: none;
    display: block;
    margin:0 auto;
    margin-top: 10px;
    padding: 0 20px;

}
.title label:nth-child(1){
    color: #5C5C5C;
    font-size: 24px;
}
.title label:nth-child(2){
    color: #194793;
    font-size: 13px;
}
.trajectory label:nth-child(1){
    color: #ffffff;
    font-size: 18px;
}
.trajectory label:nth-child(2){
    color: #ffffff;
    font-size: 13px;
    margin-top: 3px;
}
label{
    display: block;
}
.area-2{
    /* width: 30%;
    float: left; */
    height: 98px;
    padding: 23px 0px 23px 0px;
    text-align: end;
    /* line-height: 98px; */
}
.area-2 span:nth-child(1){
    color: #5C5C5C;
    font-size: 13px;
    display: block;
    height: 28px;
    margin-top: 15px;
}
.area-2 span:nth-child(2){
    color: #C5A86E;
    font-size: 34px;
}
.area-3{
    /* width: 30%;
    float: right; */
    margin-right: 30px;
    height: 98px;
    padding: 23px 0px 23px 30px;
}
ul{
    list-style: none;
}
li{
    width: 87px;
    height: 87px;
    float: left;
    background:#ffffff;
    border-radius:5px;
}
li:not(:first-child){
     margin-left: 20px;
}
li img{
    width: 35px;
    height: 38px;
    display: block;
    margin: 13px auto 0 auto;

}
li label{
    color: #919191;
    font-size: 12px;
    /* display: block; */
    text-align: center;
    /* margin-top: 10px; */
    height: 32px;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.pointer{
    cursor:pointer;
}
.epctxt{ margin-top: 3px;}
/* .YearMonth{
  font-style: normal;
  font-weight: bold;
} */
/* @media screen and  ( min-width: 1000px){
    .area-1{
    width: 20%;
    }
    .area-2{
    width: 25%;
    }
}
@media screen and  ( min-width: 1360px){
    .area-1{
    width: 16%;
    }
    .area-2{
    width: 23%;
    }
}
@media screen and  ( min-width: 1600px){
    .area-1{
    width: 14%;
    }
    .area-2{
    width: 23%;
    }
} */
</style>



// WEBPACK FOOTER //
// src/pages/performance/user.vue